import { Text, TextProps } from '@chakra-ui/react'

const JGoogleIcon = (props) => {
  return (
    <Text
      as='span'
      className='material-symbols-outlined'
      {...props}
    >
      {props.name}
    </Text>
  )
}

export default JGoogleIcon
